import React from "react";
import * as Icons from "lucide-react";

// Ilustraciones simplificadas (no capturas reales) con el botón exacto resaltado.
const Phone = ({ children, testid }) => (
  <div data-testid={testid} className="mx-auto w-full max-w-[260px] rounded-[28px] border-[6px] border-[#1C2421] bg-[#F2F2F7] overflow-hidden shadow-md">
    <div className="h-4 bg-[#1C2421] mx-auto w-20 rounded-b-xl" />
    {children}
  </div>
);
const Halo = ({ children, label }) => (
  <span className="relative inline-flex flex-col items-center">
    <span className="absolute -inset-2 rounded-xl ring-4 ring-[#D97706] animate-pulse" />
    {children}
    {label && <span className="absolute top-full mt-3 whitespace-nowrap text-[11px] font-bold text-white bg-[#D97706] rounded-full px-2 py-0.5">{label}</span>}
  </span>
);
const Arrow = () => <Icons.ArrowDown size={26} className="text-[#D97706] mx-auto animate-bounce" strokeWidth={3} />;
const Web = () => (
  <div className="h-28 bg-white m-2 rounded-lg p-3 space-y-2">
    <div className="h-3 w-2/3 bg-[#3A6B56]/70 rounded" /><div className="h-2 w-full bg-[#E5DFD5] rounded" /><div className="h-2 w-5/6 bg-[#E5DFD5] rounded" />
  </div>
);

export const IlusCompartir = () => (
  <Phone testid="ilus-ios-compartir">
    <Web />
    <Arrow />
    <div className="bg-white/95 border-t border-[#D1D1D6] px-4 pt-3 pb-8 flex items-center justify-between text-[#007AFF]">
      <Icons.ChevronLeft size={22} /><Icons.ChevronRight size={22} className="opacity-40" />
      <Halo label="Compartir"><Icons.Share size={24} /></Halo>
      <Icons.BookOpen size={22} /><Icons.Copy size={22} />
    </div>
  </Phone>
);

export const IlusMenu = () => (
  <Phone testid="ilus-ios-menu">
    <div className="bg-white m-2 rounded-xl divide-y divide-[#E5E5EA] text-[13px] text-[#1C2421]">
      {[["Copiar", Icons.Copy], ["Añadir a favoritos", Icons.Star], ["Añadir a la lista de lectura", Icons.Glasses]].map(([t, I]) => (
        <div key={t} className="flex items-center justify-between px-3 py-2.5 opacity-50">{t}<I size={16} /></div>
      ))}
      <div className="px-1 py-1">
        <Halo>
          <div className="flex items-center justify-between w-[218px] px-2 py-2 font-bold bg-[#FEF3C7] rounded-lg">Añadir a pantalla de inicio<Icons.SquarePlus size={18} /></div>
        </Halo>
      </div>
      <div className="flex items-center justify-between px-3 py-2.5 opacity-50">Imprimir<Icons.Printer size={16} /></div>
    </div>
    <div className="h-6" />
  </Phone>
);

export const IlusAnadir = () => (
  <Phone testid="ilus-ios-anadir">
    <div className="bg-white px-3 py-3 flex items-center justify-between text-[12px]">
      <span className="text-[#007AFF]">Cancelar</span>
      <span className="font-bold text-[#1C2421]">Añadir a inicio</span>
      <Halo><span className="text-[#007AFF] font-bold text-[14px]">Añadir</span></Halo>
    </div>
    <div className="bg-white m-2 mt-4 rounded-xl p-3 flex items-center gap-3">
      <img src="/apple-touch-icon.png" alt="" className="w-12 h-12 rounded-xl" />
      <div><p className="font-bold text-[#1C2421] text-sm">AL DÍA</p><p className="text-[11px] text-[#8E8E93]">Se añadirá un icono a tu pantalla de inicio</p></div>
    </div>
    <div className="h-20" />
  </Phone>
);

export const IlusIcono = () => (
  <Phone testid="ilus-ios-icono">
    <div className="bg-gradient-to-b from-[#A7C4B5] to-[#6E9A86] p-4 grid grid-cols-4 gap-3 h-48">
      {Array.from({ length: 7 }).map((_, i) => <div key={i} className="w-10 h-10 rounded-xl bg-white/40" />)}
      <Halo><img src="/apple-touch-icon.png" alt="AL DÍA" className="w-10 h-10 rounded-xl" /></Halo>
    </div>
  </Phone>
);

export const IlusAndroidMenu = () => (
  <Phone testid="ilus-android-menu">
    <div className="bg-white px-3 py-2.5 flex items-center gap-2 text-[#5F6368]">
      <div className="flex-1 h-7 rounded-full bg-[#F1F3F4] text-[11px] flex items-center px-3">aldiafacil.es</div>
      <Halo><Icons.EllipsisVertical size={20} /></Halo>
    </div>
    <div className="bg-white m-2 ml-12 rounded-lg shadow text-[13px] text-[#1C2421] divide-y divide-[#EEE]">
      <div className="px-3 py-2 opacity-50">Nueva pestaña</div>
      <div className="px-3 py-2 opacity-50">Historial</div>
      <div className="p-1"><Halo><div className="w-[160px] px-2 py-2 font-bold bg-[#FEF3C7] rounded">Instalar aplicación</div></Halo></div>
      <div className="px-3 py-2 opacity-50">Configuración</div>
    </div>
    <div className="h-8" />
  </Phone>
);
